import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaInfoCircle } from 'react-icons/fa';
import * as R from 'ramda';

import useEditProtocolContext from 'App/features/ProtocolManager/EditProtocolPage/useEditProtocolContext';
import SelectField from 'Shared/form/SelectField';

const propTypes = {};

const defaultProps = {};

function ActivityToTrigger() {
    const {
        state: { availableRuleAssessments },
    } = useEditProtocolContext();
    const updatedAvailableRuleAssessments = availableRuleAssessments.map((assessment) => {
        const newAssessment = { ...assessment };
        if (assessment.label === 'Referral') {
            newAssessment.options = assessment.options.filter((option) => option.name !== 'Appeal');
        }
        return { ...newAssessment };
    });
    return (
        <SelectField
            fieldName="activityToTrigger"
            label={
                <span>
                    Activity to Trigger
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="activity-trigger-tooltip">The activity that will be triggered</Tooltip>}
                    >
                        <FaInfoCircle className="info-icon float-right" />
                    </OverlayTrigger>
                </span>
            }
            required
            options={updatedAvailableRuleAssessments}
            getOptionValue={R.prop('id')}
            getOptionLabel={R.prop('name')}
            placeholder="Select activity"
        />
    );
}

ActivityToTrigger.propTypes = propTypes;
ActivityToTrigger.defaultProps = defaultProps;

export default ActivityToTrigger;
